import { PhoneOutlined, QuestionCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { useViewport } from "@bindeleddet/core/hooks";
import { FooterLink } from "./FooterNavLinks.styled";

import { FOOTER_BREAKPOINT } from "../constants";

const { Paragraph } = Typography;

const FooterNavLinks = () => {
  const { width } = useViewport();

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32,
      }}
      style={{ width: "70%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "3%", paddingBottom: "3%" }}
    >
      <Col span={width < FOOTER_BREAKPOINT ? 24 : 8}>
        <Paragraph>
          <FooterLink to="/contact-us/">
            <QuestionCircleOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Ofte stilte spørsmål
          </FooterLink>
        </Paragraph>
      </Col>
      <Col span={width < FOOTER_BREAKPOINT ? 24 : 8}>
        <Paragraph>
          <FooterLink to="/contact-us/">
            <PhoneOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Kontaktinformasjon
          </FooterLink>
        </Paragraph>
      </Col>
      <Col span={width < FOOTER_BREAKPOINT ? 24 : 8}>
        <Paragraph>
          <FooterLink to="/about-us/members/">
            <TeamOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Våre medlemmer
          </FooterLink>
        </Paragraph>
      </Col>
    </Row>
  );
};

export default FooterNavLinks;
